/* eslint-disable import/prefer-default-export */
import { apiV2 } from '../lib/baseAxios';
import {
  PersonalAccessToken,
  PersonalAccessTokenInitial,
  CreateTokenArgs,
} from '../types/PersonalAccessToken';

const TOKENS_PATH = '/account/tokens';

interface ErrorResponse {
  success: false;
  message: string;
}

interface SuccessResponse<T> {
  success: true;
  data: T;
}

type ListTokensResponse =
  | SuccessResponse<PersonalAccessToken[]>
  | ErrorResponse;

type CreateTokenResponse =
  | SuccessResponse<PersonalAccessTokenInitial>
  | ErrorResponse;

type RevokeTokenResponse =
  | SuccessResponse<{ tokenInfo: PersonalAccessToken }>
  | ErrorResponse;

type RotateTokenResponse =
  | SuccessResponse<PersonalAccessTokenInitial>
  | ErrorResponse;

type PermissionsResponse =
  | SuccessResponse<{ permissions: string[] }>
  | ErrorResponse;

export const tokenService = {
  async listTokens(): Promise<PersonalAccessToken[]> {
    const response = await apiV2.get<ListTokensResponse>(`${TOKENS_PATH}`);
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data;
  },

  async createToken(
    request: CreateTokenArgs
  ): Promise<PersonalAccessTokenInitial> {
    const response = await apiV2.post<CreateTokenResponse>(
      `${TOKENS_PATH}`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data;
  },

  async revokeToken(
    tokenId: string
  ): Promise<{ tokenInfo: PersonalAccessToken }> {
    const response = await apiV2.delete<RevokeTokenResponse>(
      `${TOKENS_PATH}/${tokenId}`
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data;
  },

  async rotateToken(tokenId: string): Promise<PersonalAccessTokenInitial> {
    const response = await apiV2.post<RotateTokenResponse>(
      `${TOKENS_PATH}/${tokenId}/rotate`
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data;
  },

  async listPermissions(): Promise<{ permissions: string[] }> {
    const response = await apiV2.get<PermissionsResponse>(
      `/account/permissions`
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data;
  },
};
